import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/[variants]/account/points-mall-detail/[id]/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/RouteMessagesProvider.tsx");
